import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';

export type FcmTokenPayload = {
  token: string;
};

export async function sendFcmToken(payload: FcmTokenPayload) {
  const { data } = await httpClient.post(endpoints.fcm.store, payload);
  return data;
}

export async function removeFcmToken(payload: FcmTokenPayload) {
  const { data } = await httpClient.post(endpoints.fcm.remove, payload);
  return data;
}
